@import '../../../../../../constants/spacing.module.less';

.provider-table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btn-section {
  display: flex;
  align-items: center;
  > :not(:last-child) {
    margin-right: @space-16;
  }
}
